import React, { useState, useEffect } from 'react';
import { createModel } from 'hox';
import useGlobalModel from '@/model/globalModel';
import { assetsInventoryService } from '../../assetsInventoryService';
import { convertRes2Blob } from '@/utils/exportFile';
import { message } from 'antd';
import { useLockFn } from 'ahooks';
import {
	ISCMAssetsInventoryFormFields,
	ISCMAssetsInventoryInsert,
	ISCMAssetsInventoryUpdate,
	ISCMSDcGoodsDetail,
	ISCMSDcGoodsOne,
} from '../../assetsInventoryTypes';
import { globalPrompt } from '@/components/message';
import { ISCMSDcSelectGoods } from './AddGoodsModal';
import { CLIENT_APP_CODE } from '@/utils/constants';
import { formatInt, formatNum, momentFormat } from '@/utils/utils';
import useNavModel from '@/model/navModel';
import moment from 'moment';
import { useDictModel } from '@/views/base/dict/dictModel';

export type ISCMSDcDescType = {
	inventoryNumAll: number;
	realNumAll: number;
	differenceNumAll: number;
	differenceAmountAll: number;
	[key: string]: any;
};
const initDesc = {
	inventoryNumAll: 0, //实际总价合计 （数量*单价）
	//对应展示字段
	realNumAll: 0, //调拨数量
	differenceNumAll: 0, //调拨总计   （去除下浮）
	differenceAmountAll: 0, //调拨总计   （去除下浮）
};

export const useAssetsInventoryDetailsModel = createModel(function () {
	const {
		user: { userName },
	} = useGlobalModel();
    const { getSelectedDictValueOne,getSelectedDictOne, getTreeNodeName } = useDictModel(() => []);
	const initFormVal = {
		// createUser: userName,
		applier: userName,
		branchOut: CLIENT_APP_CODE,
		discountTotalAmount: '0.00', //优惠总额
		favorableAmount: '0', //整单优惠
		aggregateAmount: '0.00', //应付金额
		discountRate: '0', //整单下浮
	} as ISCMAssetsInventoryFormFields;
    const { selectedNavId, replaceNav, findNav } = useNavModel()
	//编辑缓存
	const [editFormVal, setEditFormVal] = useState<ISCMAssetsInventoryFormFields>(initFormVal);
	const [editGoodsList, setEditGoodsList] = useState<ISCMSDcGoodsDetail[]>([]);
	const [editDesc, setEditDesc] = useState<ISCMSDcDescType>(initDesc);
	//页面弹窗
    const [materialCodeVisible, setMaterialCodeVisible] = useState<boolean>(false)
	// const [materialList, setMaterialList] = useState<any>([]);
	//新增缓存
	const [addFormVal, setAddFormVal] = useState<ISCMAssetsInventoryFormFields>(initFormVal);
	const [addGoodsList, setAddGoodsList] = useState<ISCMSDcGoodsDetail[]>([]);
	const [addDesc, setAddDesc] = useState<ISCMSDcDescType>(initDesc);

	// 控制先保存
	const [saveBtn, setSaveBtn] = useState<boolean>(false);
	// 保存按钮的loading效果
	const [saveBtnLoading, setSaveBtnLoading] = useState<boolean>(false);
    //导入点击
    const [changeImport, setChangeImport] = useState<boolean>(true)
	
	useEffect(() => {
		let newDesc: ISCMSDcDescType = { ...initDesc };
		editGoodsList.forEach((item) => {
			newDesc.inventoryNumAll += Number(item.inventoryNum);
			newDesc.realNumAll += Number(item.realNum);
			newDesc.differenceNumAll += Number(item.differenceNum);
			newDesc.differenceAmountAll += Number(item.differenceAmount);
		});
		setEditDesc(newDesc);
	}, [editGoodsList]);

	useEffect(() => {
		let newDesc: ISCMSDcDescType = { ...initDesc };
		addGoodsList.forEach((item) => {
			newDesc.inventoryNumAll += (item.inventoryNum as number);
			newDesc.realNumAll += (item.realNum as number);
			newDesc.differenceNumAll += (item.differenceNum as number);
			newDesc.differenceAmountAll += Number(item.differenceAmount as number);
		
		});
		setAddDesc(newDesc);
	}, [addGoodsList]);

	useEffect(() => {
		resetAddCatch();
		// setAddFormVal({ ...initFormVal, createUser: userName });
		setAddFormVal({ ...initFormVal});
	}, []);

	//表单新增修改
	const updateAddFormVal = (val: object | null) => {
		val ? setAddFormVal({ ...addFormVal, ...val }) : setAddFormVal(initFormVal);
	};
	//表单编辑修改
	const updateEditFormVal = (val: object | null) => {
		val ? setEditFormVal({ ...editFormVal, ...val }) : setEditFormVal(initFormVal);
	};

	//重置缓存
	const resetEditCatch = () => {
		updateEditFormVal(null); //表单
		setEditGoodsList([]); //详情商品列表
		setEditSelectGoods([]); //弹框已选商品
	};
	const resetAddCatch = () => {
		updateAddFormVal(null);
		setAddGoodsList([]);
		setAddSelectGoods([]);
	};

	//获取一条数据
	const getSDcDetailOne = async (id: string) => {
		let { retData } = await assetsInventoryService.one(id);
		let { details, ...formVal } = retData;
		if (retData) {
			setEditGoodsList(() => details.map((item) => ({
				 ...item,
				 key: item.id, 
				 temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000),
			})));
			setEditFormVal({ ...formVal,				 
				// endTime:'moment(formVal.endTime).format("YYYY-MM-DD HH:mm")',
			    // startTime:moment(formVal.startTime).format("YYYY-MM-DD HH:mm"), 
				endTime:formVal.endTime? moment(formVal.endTime):'',
			    startTime:formVal.startTime? moment(formVal.startTime):'' ,
				stocktakingUser:formVal.stocktakingUser?(formVal.stocktakingUser).split(','):[],
				createTime:formVal.createTime? momentFormat(formVal.createTime):'' ,
		});
		}
		// setMaterialList(details)
		return retData;
	};

	//表单物资校验 (开单数量不能为0)
	const verifyGoods = (mode: string): boolean => {
		let goods = mode === 'edit' ? editGoodsList : addGoodsList;
		if (!goods.length) {
			message.warning('请添加物品明细');
			return false;
		}
		// let zeroNum = goods.filter((item) => !+item.num);
		// if (zeroNum.length) {
		// 	message.warning(
		// 		`【${zeroNum.map((item) => item.materialName).join()}】物资的开单数量不能为0`
		// 	);
		// 	return false;
		// }
		return true;
	};

	//新增 Api
	const insertSDc = useLockFn(async (val: ISCMAssetsInventoryFormFields) => {
		setSaveBtnLoading(true);
		try {
			let data: ISCMAssetsInventoryInsert = {
				...val,
				details: addGoodsList,
				startTime:val.startTime?moment(val.startTime).format("YYYY-MM-DD HH:mm"):'',
				endTime:val.startTime?moment(val.endTime).format("YYYY-MM-DD HH:mm"):'',
				stocktakingUser:(val.stocktakingUser&&val.stocktakingUser.length>0)?(val.stocktakingUser).toString():null
			};
			let { retData } = await assetsInventoryService.insert(data);
			globalPrompt("message", { text: "物资盘点新增成功", type: "success" })
			setSaveBtnLoading(false);
			replaceNav(selectedNavId, '3-1')
			resetAddCatch();
			return retData;
		} catch (error) {
			setSaveBtnLoading(false);
		}
	});

	//编辑 Api
	const updateSDc = useLockFn(async (val: ISCMAssetsInventoryFormFields & { id: string }) => {
		setSaveBtnLoading(true);
		try {
			let data: ISCMAssetsInventoryUpdate = {
				...val,
				id: editFormVal.id,
				details: editGoodsList,
				startTime:val.startTime?moment(val.startTime).format("YYYY-MM-DD HH:mm"):'',
				endTime:val.startTime?moment(val.endTime).format("YYYY-MM-DD HH:mm"):'',
				stocktakingUser:(val.stocktakingUser&&val.stocktakingUser.length>0)?(val.stocktakingUser).toString():null			
			};
			let { retData } = await assetsInventoryService.update(data);
			globalPrompt("message", { text: "物资盘点编辑成功", type: "success" })
			setSaveBtnLoading(false);
			replaceNav(selectedNavId, '3-1')
			resetEditCatch()
			return retData;
		} catch (error) {
			setSaveBtnLoading(false);
		}
	});


	/**
	 * 商品新增
	 */
	const [addGoodsModal, setAddGoodsModal] = useState<boolean>(false); //商品弹框
	const [editSelectGoods, setEditSelectGoods] = useState<ISCMSDcSelectGoods[]>([]); //已选的商品
	const [addSelectGoods, setAddSelectGoods] = useState<ISCMSDcSelectGoods[]>([]); //已选的商品
	// 操作数据先保存
	const [buttonControl, setButtonControl] = useState<boolean>(false);

	//添加商品  默认数量字段为1
	const add = async (record: ISCMSDcSelectGoods, mode: string) => {
		const isEdit: boolean = mode === 'edit';
		isEdit
			? setEditSelectGoods((origin) => [...origin, { ...record, sDcNum: 1 }])
			: setAddSelectGoods((origin) => [...origin, { ...record, sDcNum: 1 }]);
	};

	//删除商品 选中的
	const remove = (record: ISCMSDcSelectGoods, mode: string) => {
		mode === 'edit'
			? setEditSelectGoods((origin) => origin.filter((item) => item.id !== record.id))
			: setAddSelectGoods((origin) => origin.filter((item) => item.id !== record.id));
	};

	//选中的物资转商品
	const transformsToSDcGoods = (async (selectList: ISCMSDcSelectGoods[], mode: string,type='add') => {
		if (mode === 'edit') {
			setButtonControl(true);
			setSaveBtn(true);
		}
		const isEdit: boolean = mode === 'edit';
		let codeList: string[] = [];
		let goodsList = mode === 'add' ? addSelectGoods : editSelectGoods;
		goodsList.forEach((item) => {
			codeList.push(item.materialCode);
		});
		if(type=='add' &&codeList.length === 0){
            setAddGoodsModal(false)
            return
        }
		const newDetailData:any = [];
		selectList.forEach((item) => {
			//没有最新进价，用物资档案进货价计算。
			let price = +item.price;
			//库存数量                      //盘点数量
			let inventoryNum = +formatInt(item.inventoryNum??item.num);
			let realNum = item.realNum?item.realNum:1;
			//差异量=实物盘点量 - 账面库存量，
			let differenceNum = realNum - inventoryNum;
			//差异金额=品牌最新进价*差异量
			let differenceAmount = (differenceNum * price).toFixed(2);

			let result = "";
			//盘点结果 （库存 === 盘点量：相符 || 库存 > 盘点量：盘亏 ||  库存 < 盘点量：盘盈 ）
			if (inventoryNum > realNum) {
				result = "盘亏"
			} else if (inventoryNum < realNum) {
				result = "盘盈"
			} else if (inventoryNum == realNum){
				result = "相符"
			}	
			console.log(inventoryNum,realNum)	
			// debugger
			newDetailData.push({
				materialCode:item.materialCode,
				barCode:item.barCode,
				materialName:item.materialName,
				model:item.model,
				typeCode:item.typeCode,
				code:item.code,
				price:type=='add'?price:item.price,
				unitCode:item.unitCode,
				detailsId:type=='add'?item.id:item.detailsId,
				inventoryNum:type=='add'?inventoryNum:item.inventoryNum,
				warehouseName:item.warehouseName,
				amount:item.amount??item.price,
				warehouseCode:item.warehouseCode,
				shelfCode:item.shelfCode,
				note:"",
				temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000),
				realNum:type=='add'?realNum:item.realNum,
				differenceNum:type=='add'?differenceNum:item.differenceNum,
				differenceAmount:type=='add'?differenceAmount:item.differenceAmount,
				result:item.result??result,
				user:item.user,
				deposit:item.deposit,
				typeName:item.typeName,
				unitName:getTreeNodeName(item.unitCode) ?? '',
				userCode:item.userCode,
				brandName:item.brandName??"",
				md5:item.md5,
				fileName:item.fileName

			});
		});
		isEdit
			? setEditGoodsList((origin) => [...origin, ...newDetailData])
			: setAddGoodsList((origin) => [...origin, ...newDetailData]);
		isEdit ? setEditSelectGoods([]) : setAddSelectGoods([]);
		setAddGoodsModal(false);
	});

    const onComplete = async (params: any) => {
        let { retData } = await assetsInventoryService.complete(params);
        return retData
    }
    const onFinalAudit = async (params: any) => {
        let { retData } = await assetsInventoryService.finalAudit(params);
        return retData
    }
	/**
	 * 打印
	 */
	const [print, setPrint] = useState<boolean>(false);
	const [historyVisible, setHistoryVisible] = useState<boolean>(false);
	const [historyRow, setHistoryRow] = useState<any>({});
	//下载模板
	const downloadTpl = async () => {
		let result = await assetsInventoryService.downloadTpl();
		convertRes2Blob(result)
	}
	return {
		editFormVal,
		addFormVal,
		addGoodsModal,
		setAddGoodsModal,
		updateAddFormVal,
		updateEditFormVal,
		resetEditCatch,
		resetAddCatch,
		/**api */
		insertSDc,
		updateSDc,
		getSDcDetailOne,
		/**商品详情 */
		editSelectGoods,
		setEditSelectGoods,
		addSelectGoods,
		setAddSelectGoods,
		addGoodsList,
		setAddGoodsList,
		editGoodsList,
		setEditGoodsList,
		add,
		remove,
		verifyGoods,
		editDesc,
		addDesc,
		print,
		setPrint,
		historyVisible,
		setHistoryVisible,
		historyRow,
		setHistoryRow,
		buttonControl,
		setButtonControl,
		saveBtn,
		setSaveBtn,
		saveBtnLoading,
		setSaveBtnLoading,
		transformsToSDcGoods,
		materialCodeVisible, 
		setMaterialCodeVisible,
		onFinalAudit,onComplete,
		downloadTpl,
		changeImport, setChangeImport
		// materialList, setMaterialList
	};
});
